<template>
  <v-dialog
    v-model="dialog"
    max-width="1000"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            small
            @click.stop=""
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-history
            </v-icon>
          </v-btn>
        </template>
        <span>View Employee History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      :title="((personalDetail || {}).person || {}).name"
      text="List of Employee's Personal Record Histories"
      class="mb-0"
    >
      <v-row class="py-0 mb-n6">
        <v-col>
          <span class="font-weight-bold font-16">
            Histories
          </span>
          <employee-profile-general-info-personal-detail-history-dialog-create
            v-if="$hasPermissionTo(['update employees details']) && !isMyProfile && !isResigned"
            :person-uid="personalDetail.person_uid"
            @updated="loadData()"
          />
        </v-col>
      </v-row>
      <v-data-table
        :headers="historyHeaders"
        :items="histories"
        disable-pagination
        hide-default-footer
        dense
        class="mt-5 mb-0"
        :style="`border:1px solid rgba(0,0,0,.12)`"
      >
        <template v-slot:item.subject="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ ((item.subject).replace(/_/g, ' ')).toUpperCase() }}
            </span>
          </div>
        </template>

        <template v-slot:item.start_date="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ $moment(item.start_date).format('DD MMM YYYY') }}
            </span>
          </div>
        </template>

        <template v-slot:item.end_date="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ $moment(item.end_date).format('DD MMM YYYY') }}
            </span>
          </div>
        </template>

        <template 
          v-slot:item.action="{ item }"
        >
          <div style="white-space:nowrap">
            <employee-profile-general-info-personal-detail-history-dialog-edit
              v-if="$hasPermissionTo(['update employees details']) && !isMyProfile && !isResigned"
              :history="item"
              @updated="loadData()"
            />
            <employee-profile-general-info-personal-detail-history-dialog-delete
              v-if="$hasPermissionTo(['update employees details']) && !isMyProfile && !isResigned"
              :history="item"
              @deleted="loadData()"
            />
          </div>
        </template>
      </v-data-table>
    </material-card> 
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoPersonalDetailHistoryDialogCreate: () => import('@/components/hris/employee/profile/general-info/personal-detail/history/DialogCreate'),
      EmployeeProfileGeneralInfoPersonalDetailHistoryDialogEdit: () => import('@/components/hris/employee/profile/general-info/personal-detail/history/DialogEdit'),
      EmployeeProfileGeneralInfoPersonalDetailHistoryDialogDelete: () => import('@/components/hris/employee/profile/general-info/personal-detail/history/DialogDelete'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      personalDetail: {
        type: Object,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
      histories: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        headings: [
          {
            text: 'Subject', 
            sortable: false, 
            value: 'subject',
            divider: true,
          },
          {
            text: 'Previous Value', 
            sortable: false, 
            value: 'previous_value',
            divider: true,
          },
          {
            text: 'Start Date',
            sortable: false,
            value: 'start_date',
            divider: true,
            align: 'center',
          },  
          {
            text: 'End Date', 
            sortable: false, 
            value: 'end_date',
            divider: true,
            align: 'center',
          },                   
        ],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
      historyHeaders () {
        let originalTab = [...this.headings]
        if (this.$hasPermissionTo(['update employees details']) && !this.isMyProfile && !this.isResigned) {
          originalTab.splice(originalTab.length, 0, {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
            width: 100,
          })
        }

        return originalTab
      },
    },
    methods: {
      loadData () {
        this.$emit('updated')
        this.dialog = false
      },
    },
  }
</script>

<style scoped>
  .font-16{
    font-size:16px;
  }
</style>
